import { render, staticRenderFns } from "./crudPages.vue?vue&type=template&id=f767648c&scoped=true&"
import script from "./crudPages.vue?vue&type=script&lang=js&"
export * from "./crudPages.vue?vue&type=script&lang=js&"
import style0 from "./crudPages.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudPages.vue?vue&type=style&index=1&id=f767648c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f767648c",
  null
  
)

export default component.exports